import { Box, useTheme } from '@chakra-ui/react';

const StyledBarPercent = ({
  dataTestId,
  percent,
  isNegative = false,
  isZeroPercent = false,
  colorPositive,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Box
      height='10px'
      width={`${percent > 100 ? 100 : percent}px`}
      borderRadius={
        isZeroPercent ? '2px' : isNegative ? '2px 0 0 2px' : '0 2px 2px 0'
      }
      clipPath={
        percent > 100
          ? 'polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%)'
          : 'none'
      }
      {...(isZeroPercent
        ? { position: 'absolute', top: '25%', left: '-1px' }
        : {})}
      backgroundColor={colorPositive || theme.colors.green}
      data-testid={dataTestId}
      {...props}
    />
  );
};

export default StyledBarPercent;
